export const translations = {
  es: {
    nav: {
      work: 'Obra',
      about: 'Acerca',
      exhibitions: 'Eventos',
      contact: 'Contacto'
    },
    hero: {
      name: 'Yael Martínez',
      title: 'Fotógrafo',
      subtitle: 'Miembro de Magnum Photos',
      description: 'Explorando las comunidades fragmentadas de México y Latinoamérica a través de la lente poética del documentalismo'
    },
    work: {
      title: 'Proyectos Seleccionados',
      viewProject: 'Ver Proyecto'
    },
    about: {
      title: 'Acerca de Yael',
      bio: 'Yael Martínez (Guerrero, México, 1984) es un fotógrafo cuyo trabajo emerge desde Guerrero, documentando las fracturas sociales de México y Latinoamérica con una mirada íntima y profundamente humana. Su obra se sitúa en la intersección entre el documentalismo y el arte conceptual, transformando el trauma colectivo en narrativas visuales poéticas que trascienden la representación literal de la violencia.',
      bio2: 'Miembro pleno de Magnum Photos desde 2024—previamente nominado en 2020 y asociado en 2022—Martínez se ha consolidado como una de las voces más importantes de la fotografía documental contemporánea. Su trabajo investiga las comunidades fragmentadas por la violencia del crimen organizado, las desapariciones forzadas y el impacto social de estos fenómenos, pero lo hace desde una aproximación que rechaza el sensacionalismo y busca, en cambio, expresar la ausencia, el vacío y la resiliencia.',
      bio3: 'Su metodología es única: interviene físicamente sus fotografías—perforándolas, retroiluminándolas, creando metáforas visuales—para representar lo que no puede ser fotografiado directamente. En proyectos como "Luciérnagas", iniciado tras la desaparición de tres miembros de su propia familia, transforma puntos de luz en símbolos de memoria y resistencia. En "La Casa Que Sangra", documenta el vacío que habita en los espacios domésticos marcados por la ausencia. Sus rituales fotográficos, como en "La Sangre y la Lluvia", exploran la dimensión espiritual y colectiva del duelo y la sanación.',
      bio4: 'Entre sus reconocimientos más destacados se encuentran el Premio Eugene Smith en Fotografía Humanista (2019), considerado uno de los más prestigiosos en fotoperiodismo; el Wayfinder Award de National Geographic Society (2022); y múltiples premios World Press Photo (2019, 2022). Es miembro del Sistema Nacional de Creadores de Arte de México desde 2020. Su obra ha sido exhibida y publicada internacionalmente en medios como The New York Times, Time, Vogue Italia, y espacios como el International Center of Photography y la Fundación Televisa.',
      bio5: 'El trabajo de Martínez no solo documenta; cuestiona, conmemora y resiste. Su fotografía es un acto de memoria colectiva, un testimonio del dolor y la dignidad de comunidades que se niegan a ser olvidadas. A través de su lente, la oscuridad se puebla de luciérnagas—pequeñas luces que insisten en brillar contra la noche.'
    },
    footer: {
      rights: 'Todos los derechos reservados'
    },
    contact: {
      title: 'Contacto',
      email: 'contacto@yaelmarinez.com',
      instagram: '@yaelmtzv',
      instagramUrl: 'https://instagram.com/yaelmtzv'
    }
  },
  en: {
    nav: {
      work: 'Work',
      about: 'About',
      exhibitions: 'Events',
      contact: 'Contact'
    },
    hero: {
      name: 'Yael Martínez',
      title: 'Photographer',
      subtitle: 'Magnum Photos Member',
      description: 'Exploring the fragmented communities of Mexico and Latin America through the poetic lens of documentary photography'
    },
    work: {
      title: 'Selected Projects',
      viewProject: 'View Project'
    },
    about: {
      title: 'About Yael',
      bio: 'Yael Martínez (Guerrero, Mexico, 1984) is a photographer whose work emerges from Guerrero, documenting the social fractures of Mexico and Latin America with an intimate and deeply human gaze. His work stands at the intersection of documentary and conceptual art, transforming collective trauma into poetic visual narratives that transcend the literal representation of violence.',
      bio2: 'A full member of Magnum Photos since 2024—previously nominated in 2020 and associate in 2022—Martínez has established himself as one of the most important voices in contemporary documentary photography. His work investigates communities fragmented by organized crime violence, forced disappearances, and the social impact of these phenomena, but he does so from an approach that rejects sensationalism and instead seeks to express absence, emptiness, and resilience.',
      bio3: 'His methodology is unique: he physically intervenes his photographs—piercing them, backlighting them, creating visual metaphors—to represent what cannot be directly photographed. In projects like "Luciérnagas," initiated after the disappearance of three members of his own family, he transforms points of light into symbols of memory and resistance. In "La Casa Que Sangra," he documents the void that inhabits domestic spaces marked by absence. His photographic rituals, as in "La Sangre y la Lluvia," explore the spiritual and collective dimension of mourning and healing.',
      bio4: 'Among his most notable recognitions are the Eugene Smith Award in Humanistic Photography (2019), considered one of the most prestigious in photojournalism; the National Geographic Society Wayfinder Award (2022); and multiple World Press Photo awards (2019, 2022). He has been a member of Mexico\'s National System of Art Creators since 2020. His work has been exhibited and published internationally in media such as The New York Times, Time, Vogue Italia, and spaces like the International Center of Photography and Fundación Televisa.',
      bio5: 'Martínez\'s work does not merely document; it questions, commemorates, and resists. His photography is an act of collective memory, a testimony to the pain and dignity of communities that refuse to be forgotten. Through his lens, darkness becomes populated with fireflies—small lights that insist on shining against the night.'
    },
    footer: {
      rights: 'All rights reserved'
    },
    contact: {
      title: 'Contact',
      email: 'contacto@yaelmarinez.com',
      instagram: '@yaelmtzv',
      instagramUrl: 'https://instagram.com/yaelmtzv'
    }
  },
  fr: {
    nav: {
      work: 'Œuvre',
      about: 'À Propos',
      exhibitions: 'Événements',
      contact: 'Contact'
    },
    hero: {
      name: 'Yael Martínez',
      title: 'Photographe',
      subtitle: 'Membre de Magnum Photos',
      description: 'Exploration des communautés fragmentées du Mexique et d\'Amérique latine à travers l\'objectif poétique de la photographie documentaire'
    },
    work: {
      title: 'Projets Sélectionnés',
      viewProject: 'Voir le Projet'
    },
    about: {
      title: 'À Propos de Yael',
      bio: 'Yael Martínez (Guerrero, Mexique, 1984) est un photographe dont le travail émerge de Guerrero, documentant les fractures sociales du Mexique et de l\'Amérique latine avec un regard intime et profondément humain. Son œuvre se situe à l\'intersection du documentaire et de l\'art conceptuel, transformant le traumatisme collectif en récits visuels poétiques qui transcendent la représentation littérale de la violence.',
      bio2: 'Membre à part entière de Magnum Photos depuis 2024—précédemment nominé en 2020 et associé en 2022—Martínez s\'est imposé comme l\'une des voix les plus importantes de la photographie documentaire contemporaine. Son travail explore les communautés fragmentées par la violence du crime organisé, les disparitions forcées et l\'impact social de ces phénomènes, mais il le fait depuis une approche qui rejette le sensationnalisme et cherche plutôt à exprimer l\'absence, le vide et la résilience.',
      bio3: 'Sa méthodologie est unique : il intervient physiquement sur ses photographies—les perforant, les rétroéclairant, créant des métaphores visuelles—pour représenter ce qui ne peut être photographié directement. Dans des projets comme "Luciérnagas", initié après la disparition de trois membres de sa propre famille, il transforme des points de lumière en symboles de mémoire et de résistance. Dans "La Casa Que Sangra", il documente le vide qui habite les espaces domestiques marqués par l\'absence. Ses rituels photographiques, comme dans "La Sangre y la Lluvia", explorent la dimension spirituelle et collective du deuil et de la guérison.',
      bio4: 'Parmi ses reconnaissances les plus notables figurent le Prix Eugene Smith en photographie humaniste (2019), considéré comme l\'un des plus prestigieux en photojournalisme ; le Wayfinder Award de la National Geographic Society (2022) ; et de multiples prix World Press Photo (2019, 2022). Il est membre du Système national des créateurs d\'art du Mexique depuis 2020. Son œuvre a été exposée et publiée internationalement dans des médias tels que The New York Times, Time, Vogue Italia, et dans des espaces comme l\'International Center of Photography et la Fundación Televisa.',
      bio5: 'Le travail de Martínez ne se contente pas de documenter ; il questionne, commémore et résiste. Sa photographie est un acte de mémoire collective, un témoignage de la douleur et de la dignité des communautés qui refusent d\'être oubliées. À travers son objectif, l\'obscurité se peuple de lucioles—de petites lumières qui insistent pour briller contre la nuit.'
    },
    footer: {
      rights: 'Tous droits réservés'
    },
    contact: {
      title: 'Contact',
      email: 'contacto@yaelmarinez.com',
      instagram: '@yaelmtzv',
      instagramUrl: 'https://instagram.com/yaelmtzv'
    }
  }
};

export const projects = [
  {
    id: 1,
    title: 'La Casa Que Sangra',
    year: '2019',
    description: {
      es: 'Un relato visual sobre las heridas invisibles de las desapariciones forzadas. A través de imágenes, documentando el vacío que habita en las casas donde alguna vez vivió alguien que ya no está.',
      en: 'A visual account of the invisible wounds of forced disappearances. Through images, documenting the void that inhabits houses where someone who is no longer there once lived.',
      fr: 'Un récit visuel sur les blessures invisibles des disparitions forcées. À travers des images, documentant le vide qui habite les maisons où vivait autrefois quelqu\'un qui n\'est plus là.'
    },
    image: '/imagenes/casa-sangra/casa-001.JPG',
    featured: true,
    gallery: [
      '/imagenes/casa-sangra/casa-001.JPG',
      '/imagenes/casa-sangra/casa-002.JPG',
      '/imagenes/casa-sangra/casa-003.JPG',
      '/imagenes/casa-sangra/casa-004.JPG',
      '/imagenes/casa-sangra/casa-005.JPG',
      '/imagenes/casa-sangra/casa-006.JPG',
      '/imagenes/casa-sangra/casa-007.JPG',
      '/imagenes/casa-sangra/casa-008.JPG',
      '/imagenes/casa-sangra/casa-009.JPG',
      '/imagenes/casa-sangra/casa-010.JPG',
      '/imagenes/casa-sangra/casa-011.JPG',
      '/imagenes/casa-sangra/casa-012.JPG',
      '/imagenes/casa-sangra/casa-013.JPG',
      '/imagenes/casa-sangra/casa-014.JPG',
      '/imagenes/casa-sangra/casa-015.JPG'
    ]
  },
  {
    id: 2,
    title: 'La Raíz Obscura',
    year: '2016',
    description: {
      es: 'Explorando las raíces profundas de la violencia en México. Un viaje íntimo por los territorios donde la oscuridad y la luz coexisten, revelando las complejidades de las comunidades afectadas.',
      en: 'Exploring the deep roots of violence in Mexico. An intimate journey through territories where darkness and light coexist, revealing the complexities of affected communities.',
      fr: 'Explorer les racines profondes de la violence au Mexique. Un voyage intime à travers des territoires où l\'obscurité et la lumière coexistent, révélant les complexités des communautés touchées.'
    },
    image: '/imagenes/raiz-obscura/raiz-001.JPG',
    featured: true,
    gallery: [
      '/imagenes/raiz-obscura/raiz-001.JPG',
      '/imagenes/raiz-obscura/raiz-002.JPG',
      '/imagenes/raiz-obscura/raiz-003.JPG',
      '/imagenes/raiz-obscura/raiz-004.JPG',
      '/imagenes/raiz-obscura/raiz-005.JPG',
      '/imagenes/raiz-obscura/raiz-006.JPG',
      '/imagenes/raiz-obscura/raiz-007.JPG',
      '/imagenes/raiz-obscura/raiz-008.JPG',
      '/imagenes/raiz-obscura/raiz-009.JPG',
      '/imagenes/raiz-obscura/raiz-010.JPG',
      '/imagenes/raiz-obscura/raiz-011.JPG',
      '/imagenes/raiz-obscura/raiz-012.JPG'
    ]
  },
  {
    id: 3,
    title: 'La Sangre y la Lluvia',
    year: '2018',
    description: {
      es: 'Rituales ancestrales de petición de lluvia que se transforman en metáforas de purificación y sanación colectiva. Lo físico y lo espiritual se entrelazan en comunidades que buscan lavar el dolor.',
      en: 'Ancestral rain petition rituals that transform into metaphors of purification and collective healing. The physical and spiritual intertwine in communities seeking to wash away pain.',
      fr: 'Rituels ancestraux de demande de pluie qui se transforment en métaphores de purification et de guérison collective. Le physique et le spirituel s\'entrelacent dans des communautés cherchant à laver la douleur.'
    },
    image: '/imagenes/sangre-lluvia/sangre-001.JPG',
    featured: true,
    gallery: [
      '/imagenes/sangre-lluvia/sangre-001.JPG',
      '/imagenes/sangre-lluvia/sangre-002.JPG',
      '/imagenes/sangre-lluvia/sangre-003.JPG',
      '/imagenes/sangre-lluvia/sangre-004.JPG',
      '/imagenes/sangre-lluvia/sangre-005.JPG',
      '/imagenes/sangre-lluvia/sangre-006.JPG',
      '/imagenes/sangre-lluvia/sangre-007.JPG',
      '/imagenes/sangre-lluvia/sangre-008.JPG',
      '/imagenes/sangre-lluvia/sangre-009.JPG',
      '/imagenes/sangre-lluvia/sangre-010.JPG',
      '/imagenes/sangre-lluvia/sangre-011.JPG',
      '/imagenes/sangre-lluvia/sangre-012.JPG',
      '/imagenes/sangre-lluvia/sangre-013.JPG',
      '/imagenes/sangre-lluvia/sangre-014.JPG',
      '/imagenes/sangre-lluvia/sangre-015.JPG'
    ]
  },
  {
    id: 4,
    title: 'Luciérnagas',
    year: '2025',
    description: {
      es: 'Fotografías nocturnas perforadas por la luz. Cada punto luminoso representa una vida, una ausencia, una memoria. Este proyecto nace tras la desaparición de tres miembros de mi familia, transformando el trauma en resistencia poética.',
      en: 'Nocturnal photographs pierced by light. Each luminous point represents a life, an absence, a memory. This project was born after the disappearance of three members of my family, transforming trauma into poetic resistance.',
      fr: 'Photographies nocturnes percées de lumière. Chaque point lumineux représente une vie, une absence, une mémoire. Ce projet est né après la disparition de trois membres de ma famille, transformant le traumatisme en résistance poétique.'
    },
    image: '/imagenes/luciernagas/luciernaga-001.JPG',
    featured: true,
    gallery: [
      '/imagenes/luciernagas/luciernaga-001.JPG',
      '/imagenes/luciernagas/luciernaga-002.JPG',
      '/imagenes/luciernagas/luciernaga-003.JPG',
      '/imagenes/luciernagas/luciernaga-004.JPG',
      '/imagenes/luciernagas/luciernaga-005.JPG',
      '/imagenes/luciernagas/luciernaga-006.JPG',
      '/imagenes/luciernagas/luciernaga-007.JPG',
      '/imagenes/luciernagas/luciernaga-008.JPG',
      '/imagenes/luciernagas/luciernaga-009.JPG',
      '/imagenes/luciernagas/luciernaga-010.JPG',
      '/imagenes/luciernagas/luciernaga-011.JPG',
      '/imagenes/luciernagas/luciernaga-012.JPG',
      '/imagenes/luciernagas/luciernaga-013.JPG',
      '/imagenes/luciernagas/luciernaga-014.JPG',
      '/imagenes/luciernagas/luciernaga-015.JPG'
    ]
  },
  {
    id: 5,
    title: 'Somos el Sueño',
    year: '2020',
    description: {
      es: 'Una reflexión sobre la esperanza y la resiliencia de las comunidades que se niegan a ser olvidadas. Entre la realidad y el sueño, este trabajo captura momentos de resistencia cotidiana y dignidad inquebrantable.',
      en: 'A reflection on the hope and resilience of communities that refuse to be forgotten. Between reality and dreams, this work captures moments of everyday resistance and unbreakable dignity.',
      fr: 'Une réflexion sur l\'espoir et la résilience des communautés qui refusent d\'être oubliées. Entre réalité et rêve, ce travail capture des moments de résistance quotidienne et de dignité inébranlable.'
    },
    image: '/imagenes/somos-sueno/sueno-001.JPG',
    featured: true,
    gallery: [
      '/imagenes/somos-sueno/sueno-001.JPG',
      '/imagenes/somos-sueno/sueno-002.JPG',
      '/imagenes/somos-sueno/sueno-003.JPG',
      '/imagenes/somos-sueno/sueno-004.JPG',
      '/imagenes/somos-sueno/sueno-005.JPG',
      '/imagenes/somos-sueno/sueno-006.JPG',
      '/imagenes/somos-sueno/sueno-007.JPG',
      '/imagenes/somos-sueno/sueno-008.JPG',
      '/imagenes/somos-sueno/sueno-009.JPG',
      '/imagenes/somos-sueno/sueno-010.JPG',
      '/imagenes/somos-sueno/sueno-011.JPG',
      '/imagenes/somos-sueno/sueno-012.JPG'
    ]
  }
];

export const awardsRecognitions = [
  'Magnum Photos Member (2024)',
  'Wayfinder Award - National Geographic (2022)',
  'Eugene Smith Award (2019)',
  'World Press Photo (2019, 2022)'
];

// Hero background images for slideshow - Original photography by Yael Martínez
export const heroImages = [
  '/imagenes/hero/hero-001.JPG',
  '/imagenes/hero/hero-002.JPG',
  '/imagenes/hero/hero-003.JPG',
  '/imagenes/hero/hero-004.JPG',
  '/imagenes/hero/hero-005.JPG'
];

// Events data - MIGRADO A /public/eventos.json
// Los eventos ahora se cargan dinámicamente desde eventos.json
// Para actualizar eventos, editar el archivo /public/eventos.json
// Las imágenes de eventos se almacenan en /public/assets/eventos/
